import { z } from 'zod';

import type { closeCaseSchema, newCaseEventSchema, newCaseSchema } from '../schemas/cases';

import { TableRow, UserStoreTables } from './tinybase';

export type Case = TableRow<UserStoreTables, 'cases'>;

export type CaseEvent = TableRow<UserStoreTables, 'caseEvents'>;

export type CaseSupportingOfficer = TableRow<UserStoreTables, 'caseSupportingOfficers'>;

export type FullCase = Case & {
  events: CaseEvent[];
  supportingOfficers: string[];
};

export type NewCasePayload = z.infer<typeof newCaseSchema>;

export type NewCaseEventPayload = z.infer<typeof newCaseEventSchema>;

export type CloseCasePayload = z.infer<typeof closeCaseSchema>;

/** Incomplete. Ensure values align with the Chess DB (CAM_LLORDS_EVENT_TYPES.CLET_ID) */
export enum CaseEventContactMethodCode {
  HomeVisit = 3,
  GeneralInfo = 2,
}

/** Ensure values align with the Chess DB (CAM_LLORDS_COMM_TYPES.CLCT_ID) */
export enum CaseEventInOrOutCode {
  In = 1,
  Out = 2,
  NotApplicable = 3,
}

export type CaseDemandCounts = Record<string, number> & {
  total: number;
};
